import { MessageCircle, CalendarDays } from "lucide-react";
import { useBooking } from "@/context/BookingContext";

const WHATSAPP_NUMBER = "33751332507";

export const FloatingButtons = () => {
  const { openBooking } = useBooking();
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 items-end">
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        className="w-12 h-12 rounded-[2px] bg-[#25D366] shadow-md flex items-center justify-center text-white hover:scale-105 transition-transform"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-5 h-5" fill="white" />
      </a>
      <button
        onClick={() => openBooking()}
        data-testid="floating-agenda-button"
        className="w-12 h-12 rounded-[2px] bg-[#090708] shadow-md flex items-center justify-center text-[#E8C47A] hover:scale-105 transition-transform border border-[#E8C47A]/30"
        aria-label="Agenda"
      >
        <CalendarDays className="w-5 h-5" />
      </button>
    </div>
  );
};
